<template lang="pug">
.col-12
  .card
    .card-primary
      .card-header.text-primary.pl-4
        a.btn.btn-icon.btn-ticketlist-back(href="javascript:void(0)" @click="redirect()")
          i.fas.fa-arrow-left
        h4.ml-3 {{ $t("ui.ticket_list") }}
    .card-header
      .row.w-100
        .form-group.col-12.mb-1
          SubmitButton(
            icon="fa fa-retweet"
            :loading="loading"
            :text="$t('ui.refresh')"
            type="button"
            @click="getAuditList()"
            variant="primary"
            size="sm"
          ).mr-2

    .card-body
      .row
        .col-12(style="max-height: 70vh; overflow: hidden;")
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover#dsaList(style="width: 100%;")
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="8%")
                    span(:title="$t('ui.date')") {{ $t('ui.date') }}
                  th(width="8%")
                    span(:title="$t('ui.ticket_id')") {{ $t('ui.ticket_id') }}
                  th(width="8%")
                    span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                  th(width="8%")
                    span(:title="$t('ui.type')") {{ $t('ui.type') }}
                  th.text-right(width="8%")
                    span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                  th.text-right(width="8%")
                    span(:title="$t('ui.bonus_amount')") {{ $t('ui.bonus_amount') }}
                  th(width="8%")
                    span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
              tbody.clusterize-content
                tr(v-if="ticketWalletTransList.length == 0")
                  td(colspan="8").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in ticketWalletTransList")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}                  
                  td
                    span(:title="$moment(item.ticket_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.ticket_date") {{ $moment(item.ticket_date).format('YYYY-MM-DD, HH:mm:ss') }}
                  td
                    span(:title="item.ticket_id") {{ item.ticket_id }}
                  td
                    span(:title="item.member_id") {{ item.member_id }}
                  td
                    span(:title="item.request_type") {{ item.request_type }}
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(getTransactionAmount(item))" :title="$n(getTransactionAmount(item), 'currency')") {{ $n(getTransactionAmount(item), 'currency') }}
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                  td
                    span(:title="item.remark") {{ item.remark }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    ticketWalletTransList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    working_date: null,
    request_type: '',
    operator_id: '',
    member_id: ''
  }),
  computed: {
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if (this.$store.getters.ticketWalletTransList.working_date) {
        this.working_date = this.$store.getters.ticketWalletTransList.working_date;
      } else {
        this.working_date = this.$moment(new Date).format('YYYY-MM-DD');
      }

      if (this.$store.getters.ticketWalletTransList.operator_id, this.$store.getters.ticketWalletTransList.member_id && this.$store.getters.ticketWalletTransList.request_type) {
        this.operator_id = this.$store.getters.ticketWalletTransList.operator_id;
        this.member_id = this.$store.getters.ticketWalletTransList.member_id;
        this.request_type = this.$store.getters.ticketWalletTransList.request_type;
        this.getAuditList();
      }
    }
  },
  methods: {
    getTransactionAmount(item) {
      const amount = parseFloat(item.amount) || 0;
      const requestType = item.request_type || this.request_type;

      return requestType && requestType.toUpperCase() === 'WITHDRAWAL'
        ? amount * -1
        : amount;
    },
    redirect() {
      this.$emit("backClick");
    },
    getAuditList: function() {
      let url = config.transferListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operator_id,
        working_date: this.working_date,
        member_id: this.member_id,
        request_type: this.request_type
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketWalletTransList = response.data.dt;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>